/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssuesNewIssueSearchRoute } from '@jira/router-routes__admin-pages-new-issue-features-routes/src/globalSettingsIssuesNewIssueSearchRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import NewIssueSearchTransition, {
	LazyNewIssueSearchTransition,
} from './ui/spa/admin-pages/new-issue-features/new-issue-search-transition/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssuesNewIssueSearchRouteEntry: Route = createEntry(
	globalSettingsIssuesNewIssueSearchRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.new-issue-search-transition',
		// eslint-disable-next-line no-restricted-syntax
		component: NewIssueSearchTransition,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyNewIssueSearchTransition],
		canTransitionIn: () => true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
